<template>
    <b-modal v-model="show" :title="modalTitle" :hide-footer="true">
        <p>URL des campagnes enfants</p>
        <b-overlay :show="fetchingCampaignChildren">
            <b-form-group v-for="campaign in validChildrenCampaign" :key="campaign.campaign_code">
                <label class="campChildTitle">Campagne {{ campaign.campaign_code }}</label>

                <div class="modifyCamp">
                    <label>Account</label>
                    <b-form-select v-model="selectedAccount" :options="accountOptions" />
                </div>

                <div class="modifyCamp">
                    <label>Type de Coût</label>
                    <b-form-select v-model="selectedCostType" :options="costTypesOptions" />
                </div>

                <div class="modifyCamp">
                    <label>Format</label>
                    <b-form-select v-model="selectedFormat" :options="formatOptions" />
                </div>

                <div class="modifyCamp">
                    <label>Critères</label>

                    <div v-for="criteria in criterias" :key="campaign.campaign_code + '-' + criteria.key" class="criteria-block">
                        <label>{{ criteria.key }}</label>
                        <b-form-select
                            :value="selectedValuesByCriteria[criteria.key]"
                            :options="criteria.values.map((v) => ({ value: v.urn, text: v.name }))"
                            multiple
                            @change="toggleCriteriaSelection(criteria.key, $event)"
                        />
                    </div>
                </div>

                <b-btn :disabled="!campaign" @click="createProviderCampaign(campaign)" variant="primary"> Créer </b-btn>
            </b-form-group>

            <br />
        </b-overlay>
    </b-modal>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        data() {
            return {
                show: false,
                campaignCode: '',
                selectedAccount: '',
                accountOptions: [],

                linkedInLMedia: ['LIN'],
                childCampaignCode: [],
                fetchingCampaignChildren: true,
                costTypesOptions: ['CPC', 'CPM'],
                selectedCostType: 'CPM',
                formatOptions: [
                    { value: 'SPONSORED_UPDATES', text: 'Single Image Ad' },
                    { value: 'TEXT_AD', text: 'Text Ad' },
                ],
                selectedFormat: 'SPONSORED_UPDATES',
                criterias: [],
                selectedValuesByCriteria: {},
            };
        },
        computed: {
            ...mapGetters({
                successToast: 'app/successToast',
                errorToast: 'app/errorToast',
            }),
            modalTitle() {
                return 'Créer le média chez linkedin';
            },
            validChildrenCampaign() {
                const validChildrenCampaign = this.childCampaignCode.filter((cc) => this.linkedInLMedia.includes(cc.media_support_code));
                return validChildrenCampaign;
            },

            criteriasOptions() {
                return this.criterias.map((c) => ({ value: c.key, text: c.key }));
            },

            criteriasValueOptions() {
                if (!this.selectedCriteriaKey) return [];
                const current = this.criterias.find((c) => c.key === this.selectedCriteriaKey);
                if (!current) return [];
                return current.values.map((v) => ({ value: v.urn, text: v.name }));
            },
        },
        async mounted() {
            await this.getAccounts();
            await this.getCriteria();
        },
        methods: {
            toggleCriteriaSelection(criteriaKey, newSelection) {
                const current = this.selectedValuesByCriteria[criteriaKey] || [];
                const last = Array.isArray(newSelection) ? newSelection[newSelection.length - 1] : newSelection;

                if (current.includes(last)) {
                    this.$set(
                        this.selectedValuesByCriteria,
                        criteriaKey,
                        current.filter((v) => v !== last)
                    );
                } else {
                    this.$set(this.selectedValuesByCriteria, criteriaKey, [...current, last]);
                }
            },
            close() {
                this.show = false;
            },
            async open(campaignCode, childCampaignCode) {
                this.show = true;
                this.campaignCode = campaignCode;
                try {
                    const response = await this.$store.dispatch('app/genericGet', this.$store.state.app.apiCampaignUrl.concat(`/api/v1/campaign/${campaignCode}/children`));
                    for (const media of response.data) {
                        if (media.campaign_code === childCampaignCode) {
                            response.data = [media];
                        }
                    }
                    this.$set(this, 'childCampaignCode', response.data);
                } catch (error) {
                    this.errorToast('Erreur lors de la récupération des comptes');
                } finally {
                    this.fetchingCampaignChildren = false;
                }
            },
            async createProviderCampaign(code) {
                try {
                    const criterias = Object.entries(this.selectedValuesByCriteria)
                        .filter(([_, values]) => Array.isArray(values) && values.length > 0)
                        .reduce((acc, [key, values]) => {
                            acc[key] = values;
                            return acc;
                        }, {});

                    const payload = {
                        campaign_code: this.campaignCode,
                        account_id: this.selectedAccount,
                        cost_type: this.selectedCostType,
                        format: this.selectedFormat,
                        criteria: criterias,
                    };

                    await this.$store.dispatch('app/postLinkedinProviderCampaign', payload);
                    this.successToast(`La campagne fournisseur Linkedin pour la campagne ${code.campaign_code} a été créée avec succès.`);
                    this.close();
                } catch (error) {
                    this.errorToast(`Erreur lors de la création de la campagne fournisseur Linkedin pour la campagne ${code.campaign_code}`);
                }
            },

            async getAccounts() {
                try {
                    const response = await this.$store.dispatch('app/getLinkedinAccounts');
                    this.accountOptions = response.data
                        .map((acc) => ({
                            value: acc.account_id,
                            text: acc.name,
                        }))
                        .sort((a, b) => a.text.localeCompare(b.text));
                } catch (error) {
                    this.errorToast('Erreur lors de la récupération des comptes');
                }
            },
            async getCriteria() {
                try {
                    const response = await this.$store.dispatch('app/getLinkedinCriterias');
                    const criteriasData = response.data;
                    this.criterias = Object.entries(criteriasData).map(([key, values]) => ({
                        key,
                        values,
                    }));

                    this.criterias.forEach((c) => {
                        if (!Object.prototype.hasOwnProperty.call(this.selectedValuesByCriteria, c.key)) {
                            this.$set(this.selectedValuesByCriteria, c.key, []);
                        }
                    });
                } catch (error) {
                    this.errorToast('Erreur lors de la récupération des critères');
                }
            },
        },
    };
</script>
